import UAParser from 'ua-parser-js'

export const getDeviceForTracking = (): string =>
  new UAParser(navigator.userAgent).getDevice().type || 'desktop'
